import React from 'react'

const ArrowRightIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99468 5.99501C10.1821 6.18254 10.2875 6.43684 10.2875 6.70201C10.2875 6.96717 10.1821 7.22148 9.99468 7.40901L5.40168 12.002C5.21539 12.1846 4.96458 12.2862 4.70375 12.2849C4.44292 12.2836 4.19315 12.1794 4.00871 11.995C3.82428 11.8105 3.72008 11.5608 3.71876 11.2999C3.71745 11.0391 3.81911 10.7883 4.00168 10.602L7.90168 6.70201L4.00168 2.80201C3.81911 2.61572 3.71745 2.36491 3.71876 2.10408C3.72008 1.84325 3.82428 1.59348 4.00871 1.40904C4.19315 1.22461 4.44292 1.12041 4.70375 1.11909C4.96458 1.11777 5.21539 1.21944 5.40168 1.40201L9.99468 5.99501Z"
      fill="#27292D"
    />
  </svg>
)

export default ArrowRightIcon
